import type { FormEvent } from "react";

import { Button, Input } from "@/atoms";
import { strings } from "@/constants";
import {
    ButtonSizeEnum,
    ButtonTypeEnum,
    ButtonVariantEnum,
    InputTypeEnum,
} from "@/enums";

export const LoginForm = ({
    email,
    error,
    isLoading,
    onChangeEmail,
    onChangePassword,
    onForgotPassword,
    onSubmit,
    password,
}: {
    email: string,
    error: string,
    isLoading: boolean,
    onChangeEmail: (value: string) => void,
    onChangePassword: (value: string) => void,
    onForgotPassword: () => void,
    onSubmit: (event: FormEvent<HTMLFormElement>) => void,
    password: string,
}) => (
    <form
        className="space-y-5"
        onSubmit={onSubmit}
    >
        <Input
            hasError={!!error}
            label={strings.login.emailLabel}
            placeholder={strings.login.emailPlaceholder}
            type={InputTypeEnum.EMAIL}
            value={email}
            onChange={({ target }) => onChangeEmail(target.value)}
        />
        <Input
            hasError={!!error}
            label={strings.login.passwordLabel}
            placeholder={strings.login.passwordPlaceholder}
            type={InputTypeEnum.PASSWORD}
            value={password}
            isShowPasswordToggle
            onChange={({ target }) => onChangePassword(target.value)}
        />
        <div
            className="
                flex
                items-center
                justify-between
                text-sm
            "
        >
            <span className="text-text-secondary">{strings.login.forgotPassword}</span>
            <Button
                size={ButtonSizeEnum.SM}
                type={ButtonTypeEnum.BUTTON}
                variant={ButtonVariantEnum.LINK}
                onClick={onForgotPassword}
            >
                {strings.login.forgotPasswordLink}
            </Button>
        </div>
        <Button
            isLoading={isLoading}
            type={ButtonTypeEnum.SUBMIT}
            isFullWidth
        >
            {strings.login.submitButton}
        </Button>
    </form>
);
